import ServeManage from './serveManage.vue'

export default [{
    path: '/serveManage',
    name:'serveManage',
    component:ServeManage
}]